import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import Swal from "sweetalert2";
import { ConnectionService } from "./service/connection/connection.service";
import { SocketsConnectionService } from "./service/websockets/connection.service";
import { RealTimeService } from "./service/websockets/realtime.service";
import { WebsocketService } from "./service/websockets/websocket.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  providers: [SocketsConnectionService, RealTimeService, WebsocketService],
})
export class AppComponent {
  status = "ONLINE";
  isConnected = true;

  constructor(
    private connectionService: ConnectionService,
    private socketsConnectionService: SocketsConnectionService
  ) {
    this.socketsConnectionService.subscribeToSockets();
  }
}
